<template>
  <div>
    <el-tabs ref="tabs" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="Documentation" name="documentation">
        <developers-doc />
      </el-tab-pane>
      <el-tab-pane
        v-if="isOrganisationActive && userCan('auth', 'apiclient.getall')"
        label="API Keys"
        name="api"
      >
        <developers-api />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { isOrganisationActive } from "@/lib/utils";

export default {
  name: "Developers",
  components: {
    DevelopersDoc: () => import("@/components/Developers/DevelopersDoc.vue"),
    DevelopersApi: () => import("@/components/Developers/DevelopersApi.vue")
  },
  data() {
    return {
      isOrganisationActive: isOrganisationActive(),
      defaultTab: "documentation",
      activeTab: "documentation"
    };
  },
  methods: {
    handleTabClick(tab) {
      location.hash = tab.name;
    },

    initTab() {
      const initialTab =
        this.$route.hash !== "" ? this.$route.hash.substr(1) : this.defaultTab;
      setTimeout(() => {
        this.activeTab = initialTab;
      }, 1);
    }
  },

  mounted() {
    this.initTab();
  }
};
</script>
